// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 2: EXODUS
// ============================================================================
// Poziomy 14-26 (13 poziomów, 39 pytań)

export const chapter2Translations = {
  name: "Exodus",
  description: "Wyzwolenie ludu Bożego... Poznanie Boga przemienia nasze życie",
  
  spiritualWisdom: {
    principle: "Poznanie Boga wyzwala i przemienia",
    scripture: "Poznacie prawdę, a prawda was wyzwoli (Jana 8:32)",
    application: "Jak Izrael został wyzwolony z Egiptu, tak poznanie Boga wyzwala nas z duchowej niewoli"
  },
  
  levels: {
    14: {
      name: "Mojżesz Uratowany z Wód",
      challenge: "Kobieta poczęła i urodziła syna. Gdy zobaczyła, że jest piękny...",
      easy: {
        question: "W czym matka Mojżesza ukryła swego syna?",
        options: ["Jaskinia", "Koszyk z papirusu", "Kosz", "Dom"],
        hint: "To naczynie unosiło się na Nilu",
        funFact: "🏺 Koszyk z papirusu był powleczony smołą, aby był wodoodporny!"
      },
      medium: {
        question: "Kto znalazł Mojżesza wśród sitowia?",
        options: [
          "Córka faraona",
          "Egipska służąca",
          "Jego siostra Miriam",
          "Egipski kapłan"
        ],
        hint: "Członek egipskiej rodziny królewskiej",
        funFact: "👑 Ironicznie, to rodzina faraona ratuje tego, który mu się przeciwstawi!"
      },
      hard: {
        question: "Jak Boska Opatrzność wykorzystuje nawet naszych wrogów?",
        options: [
          "Nawracając ich",
          "Organizując okoliczności, aby wypełnić swoje zamiary",
          "Karząc ich",
          "Ignorując ich"
        ],
        hint: "Chodzi o dostrzeganie ręki Boga w wydarzeniach",
        funFact: "✨ Mojżesz dorastał w pałacu tego, który uciskał jego lud!"
      }
    },
    
    15: {
      name: "Płonący Krzew",
      challenge: "Anioł Pański ukazał mu się w płomieniu ognia...",
      easy: {
        question: "Co Mojżesz musiał zdjąć przed płonącym krzewem?",
        options: ["Biżuterię", "Sandały", "Płaszcz", "Turban"],
        hint: "To, co nosi się na stopach",
        funFact: "👡 Zdejmowanie butów wyraża szacunek na świętej ziemi!"
      },
      medium: {
        question: "Jakie imię objawia Bóg Mojżeszowi?",
        options: [
          "Pan",
          "JESTEM, KTÓRY JESTEM",
          "Wszechmogący",
          "Stworzyciel"
        ],
        hint: "Imię wyrażające absolutne istnienie",
        funFact: "🔥 JHWH (Jestem) objawia wieczną istotę Boga!"
      },
      hard: {
        question: "Czego uczy nas krzew, który płonie, ale się nie spala?",
        options: [
          "Magia istnieje",
          "Bóg przekracza prawa natury",
          "Ogień jest święty",
          "Rośliny są magiczne"
        ],
        hint: "Chodzi o boską naturę przekraczającą nasze pojmowanie",
        funFact: "🌿 Krzew symbolizuje, że boska obecność uświęca bez niszczenia!"
      }
    },

    16: {
      name: "Dziesięć Plag Egiptu",
      challenge: "Faraon zatwardził swoje serce i nie posłuchał ich...",
      easy: {
        question: "Jaka była pierwsza plaga Egiptu?",
        options: ["Żaby", "Woda zamieniona w krew", "Muchy", "Wszy"],
        hint: "Dotknęła Nilu, źródła życia dla Egiptu",
        funFact: "🩸 Nil był czczony jako bóg, a Bóg pokazał swoją wyższość!"
      },
      medium: {
        question: "Jaka była ostatnia i najstraszniejsza z plag?",
        options: [
          "Grad",
          "Ciemności",
          "Śmierć pierworodnych",
          "Szarańcza"
        ],
        hint: "Ta plaga bezpośrednio dotknęła rodzin",
        funFact: "😢 Ta plaga w końcu złamała pychę faraona i uwolniła Izrael!"
      },
      hard: {
        question: "Dlaczego Bóg zatwardza serce faraona?",
        options: [
          "Aby go ukarać",
          "Aby objawić swoją chwałę i moc",
          "Ze złości",
          "Aby przedłużyć cierpienie"
        ],
        hint: "Chodzi o ujawnienie, kto jest prawdziwym Bogiem",
        funFact: "⚡ Plagi dowodzą, że JHWH jest potężniejszy od wszystkich egipskich bogów!"
      }
    },

    17: {
      name: "Pascha",
      challenge: "Weźcie baranka... i pomaźcie jego krwią nadproża...",
      easy: {
        question: "Gdzie Izraelici mieli umieścić krew baranka?",
        options: [
          "Na swoich ubraniach",
          "Na nadprożach i framugach drzwi",
          "Na czołach",
          "W czaszach"
        ],
        hint: "Przy wejściu do swoich domów",
        funFact: "🩸 Krew na drzwiach była znakiem boskiej ochrony!"
      },
      medium: {
        question: "Jak mieli jeść baranka paschalnego?",
        options: [
          "Siedząc wygodnie",
          "Tylko w rodzinie",
          "Z przepasanymi biodrami, sandały na nogach, laska w ręku",
          "W milczeniu"
        ],
        hint: "Gotowi do odejścia",
        funFact: "🚶 Musieli być gotowi do szybkiego wyruszenia ku wolności!"
      },
      hard: {
        question: "Jak Baranek Paschalny zapowiada Chrystusa?",
        options: [
          "Swoją bielą",
          "Swoją zastępczą ofiarą ratującą przed śmiercią",
          "Swoją łagodnością",
          "Swoim wiekiem"
        ],
        hint: "Chodzi o ofiarę uwalniającą od potępienia",
        funFact: "🐑 Jezus jest nazwany 'Barankiem Bożym, który gładzi grzech świata'!"
      }
    },

    18: {
      name: "Przejście przez Morze Czerwone",
      challenge: "Mojżesz wyciągnął rękę nad morze...",
      easy: {
        question: "Jak Izraelici przeszli przez morze?",
        options: [
          "Łodzią",
          "Płynąc",
          "Suchą nogą",
          "Na tratwie"
        ],
        hint: "Dno morza było przejściowe",
        funFact: "🌊 Bóg przekształcił przeszkodę w drogę wyzwolenia!"
      },
      medium: {
        question: "Co stało się z Egipcjanami, którzy ścigali?",
        options: [
          "Zawrócili",
          "Zostali pochłonięci przez wody",
          "Zgubili się",
          "Przyłączyli się do Izraela"
        ],
        hint: "Wody powróciły na nich",
        funFact: "⚔️ Najpotężniejsza armia świata została zniszczona w mgnieniu oka!"
      },
      hard: {
        question: "Co symbolizuje to przejście w naszym duchowym życiu?",
        options: [
          "Ucieczkę przed problemami",
          "Przejście z niewoli grzechu do wolności w Bogu",
          "Wyższość Izraela",
          "Zniszczenie wrogów"
        ],
        hint: "Chodzi o duchową przemianę",
        funFact: "🗽 Morze Czerwone reprezentuje chrzest: śmierć dla starego, nowe życie!"
      }
    },

    19: {
      name: "Manna na Pustyni",
      challenge: "Co to jest? Bo nie wiedzieli, co to jest...",
      easy: {
        question: "Jak długo spadała manna?",
        options: ["10 lat", "20 lat", "40 lat", "50 lat"],
        hint: "Tyle samo co lat na pustyni",
        funFact: "🍞 Przez 40 lat Bóg cudownie karmił 2 miliony ludzi!"
      },
      medium: {
        question: "Co się działo, jeśli przechowywali mannę dłużej niż jeden dzień?",
        options: [
          "Stawała się smaczniejsza",
          "Mnożyła się",
          "Gnijła i śmierdziała",
          "Twardniała"
        ],
        hint: "Oprócz piątku na szabat",
        funFact: "🪱 Bóg uczył w ten sposób codziennej zależności od Niego!"
      },
      hard: {
        question: "Jak manna uczy nas zaufania?",
        options: [
          "Przez gromadzenie zapasów na przyszłość",
          "Przez poleganie na codziennej opatrzności Boga",
          "Przez ciężką pracę",
          "Przez sprawiedliwe dzielenie"
        ],
        hint: "To polega na ufaniu dzień po dniu",
        funFact: "🙏 'Chleba naszego powszedniego daj nam dzisiaj' pochodzi z tego doświadczenia!"
      }
    },

    20: {
      name: "Woda ze Skały",
      challenge: "Uderzysz w skałę, a wyjdzie z niej woda...",
      easy: {
        question: "Czym Mojżesz miał uderzyć w skałę?",
        options: ["Swoją ręką", "Swoją laską", "Kamieniem", "Młotem"],
        hint: "Narzędzie cudów Mojżesza",
        funFact: "⚡ Laska Mojżesza była narzędziem Bożej mocy!"
      },
      medium: {
        question: "Dlaczego lud szemrał przeciwko Mojżeszowi?",
        options: [
          "Nie było wody do picia",
          "Brakowało jedzenia",
          "Droga była za długa",
          "Było zbyt gorąco"
        ],
        hint: "Podstawowa potrzeba na pustyni",
        funFact: "💧 Woda jest jeszcze bardziej niezbędna niż jedzenie do przetrwania!"
      },
      hard: {
        question: "Co woda ze skały symbolizuje duchowo?",
        options: [
          "Zasoby naturalne",
          "Życie duchowe wypływające z Chrystusa, Skały",
          "Nagroda za wysiłek",
          "Boża magia"
        ],
        hint: "Paweł mówi, że tą skałą był Chrystus",
        funFact: "🗿 Chrystus jest Skałą uderzoną, z której wypływa życie wieczne!"
      }
    },

    21: {
      name: "Góra Synaj",
      challenge: "Cała góra Synaj dymiła, gdyż Pan zstąpił na nią...",
      easy: {
        question: "Ile przykazań dał Bóg?",
        options: ["5", "7", "10", "12"],
        hint: "Okrągła i doskonała liczba",
        funFact: "📜 Dziesięć Przykazań jest moralną podstawą ludzkości!"
      },
      medium: {
        question: "Na czym zostały napisane przykazania?",
        options: [
          "Papirusie",
          "Pergaminie",
          "Dwóch kamiennych tablicach",
          "Brązie"
        ],
        hint: "Trwały materiał napisany palcem Boga",
        funFact: "✍️ Napisane przez samego Boga, aby pokazać ich wieczne znaczenie!"
      },
      hard: {
        question: "Jaki jest cel Bożych przykazań?",
        options: [
          "Karać ludzi",
          "Objawić świętość Boga i prowadzić do szczęścia",
          "Tworzyć skomplikowane reguły",
          "Dzielić narody"
        ],
        hint: "Chodzi o objawienie Bożego charakteru i drogi dobra",
        funFact: "⚖️ Przykazania objawiają miłość: do Boga i do bliźniego!"
      }
    },

    22: {
      name: "Złoty Cielec",
      challenge: "Uczyń nam boga, który szedłby przed nami...",
      easy: {
        question: "Z czego Aaron uczynił złotego cielca?",
        options: [
          "Złotych monet",
          "Złotych kolczyków ludu",
          "Cennych klejnotów",
          "Złota z pustyni"
        ],
        hint: "Osobista biżuteria ofiarowana przez lud",
        funFact: "👂 Lud oddał swoją biżuterię, aby stworzyć własnego bożka!"
      },
      medium: {
        question: "Jaka była reakcja Mojżesza na widok cielca?",
        options: [
          "Płakał",
          "Modlił się",
          "Rozbił tablice prawa",
          "Tylko się rozzłościł"
        ],
        hint: "Symboliczny gest złamanego przymierza",
        funFact: "💥 Rozbicie tablic symbolizowało zerwane przymierze!"
      },
      hard: {
        question: "Dlaczego bałwochwalstwo jest tak niebezpieczne duchowo?",
        options: [
          "Jest drogie",
          "Odwraca serce od prawdziwego Boga ku stworzeniom",
          "Dzieli rodziny",
          "Jest zabronione"
        ],
        hint: "Chodzi o oddawanie stworzeniu tego, co należy do Stwórcy",
        funFact: "� Bałwochwalstwo niszczy wyłączną relację z żywym Bogiem!"
      }
    },

    23: {
      name: "Przybytek",
      challenge: "Niech mi zbudują świątynię, a będę mieszkał pośród nich...",
      easy: {
        question: "Jak nazywał się święty namiot Izraelitów?",
        options: ["Świątynia", "Przybytek", "Sanktuarium", "Arka"],
        hint: "Nazwa oznacza 'namiot spotkania'",
        funFact: "⛺ Przybytek był 'przenośnym domem' Boga ze swoim ludem!"
      },
      medium: {
        question: "Co zawierała Arka Przymierza?",
        options: [
          "Klejnoty arcykapłana",
          "Tablice prawa, manna, laska Aarona",
          "Złote monety",
          "Zwoje Tory"
        ],
        hint: "Trzy przedmioty symbolizujące przymierze z Bogiem",
        funFact: "📦 Arka zawierała 'pamiątki' Bożej wierności!"
      },
      hard: {
        question: "Co symbolizuje Przybytek w naszej relacji z Bogiem?",
        options: [
          "Budynek religijny",
          "Obecność Boga mieszkającego wśród nas i w nas",
          "Tylko miejsce ofiary",
          "Symbol narodowy"
        ],
        hint: "Chodzi o dostępną obecność Bożą",
        funFact: "🏠 'Wasze ciało jest świątynią Ducha Świętego' według Pawła!"
      }
    },

    24: {
      name: "Arcykapłan Aaron",
      challenge: "Poświęcisz Aarona i jego synów, aby byli moimi kapłanami...",
      easy: {
        question: "Kto był pierwszym arcykapłanem Izraela?",
        options: ["Mojżesz", "Aaron", "Jozue", "Eleazar"],
        hint: "Brat Mojżesza",
        funFact: "👨‍⚕️ Aaron założył linię kapłańską, która trwała ponad 1000 lat!"
      },
      medium: {
        question: "Co nosił arcykapłan na piersi?",
        options: [
          "Złoty krzyż",
          "Pektorał z dwunastoma kamieniami szlachetnymi",
          "Medalion",
          "Złoty łańcuch"
        ],
        hint: "Dwanaście kamieni reprezentujących dwanaście pokoleń",
        funFact: "💎 Arcykapłan nosił symbolicznie cały Izrael na swoim sercu!"
      },
      hard: {
        question: "Jak Jezus wypełnia rolę Arcykapłana?",
        options: [
          "Nosząc święte szaty",
          "Ofiarując własną krew raz na zawsze",
          "Służąc w świątyni",
          "Pochodząc od Aarona"
        ],
        hint: "Chodzi o doskonałą i ostateczną ofiarę",
        funFact: "✝️ Jezus jest wiecznym Arcykapłanem według porządku Melchizedeka!"
      }
    },

    25: {
      name: "Ofiary",
      challenge: "Jeśli ktoś z was chce złożyć ofiarę Panu...",
      easy: {
        question: "Jaka była codzienna ofiara w Przybytku?",
        options: [
          "Ofiara pokoju",
          "Ofiara całopalna poranna i wieczorna",
          "Ofiara za grzech",
          "Ofiara z placków"
        ],
        hint: "Dwa razy dziennie, rano i wieczorem",
        funFact: "🔥 Ogień na ołtarzu nigdy nie mógł zgasnąć!"
      },
      medium: {
        question: "Co symbolizowało włożenie rąk na zwierzę?",
        options: [
          "Błogosławieństwo",
          "Przeniesienie grzechów na ofiarę",
          "Przywiązanie do zwierzęcia",
          "Poświęcenie"
        ],
        hint: "Gest zastąpienia",
        funFact: "🤲 Zwierzę umierało zamiast grzesznika - zasada zastąpienia!"
      },
      hard: {
        question: "Jak te ofiary zapowiadają dzieło Chrystusa?",
        options: [
          "Przez ich liczbę",
          "Przez zastąpienie: niewinny umiera za winnego",
          "Przez ich koszt",
          "Przez ich piękno"
        ],
        hint: "Chodzi o zasadę niewinnego zajmującego miejsce winnego",
        funFact: "🐑 'Został przebity za nasze grzechy, zmiażdżony za nasze winy'!"
      }
    },

    26: {
      name: "Na Granicy Ziemi Obiecanej",
      challenge: "Poślę przed tobą anioła i wypędzę Kananejczyków...",
      easy: {
        question: "Ilu szpiegów wysłano na zwiady do Ziemi Obiecanej?",
        options: ["10", "12", "20", "40"],
        hint: "Po jednym z każdego pokolenia Izraela",
        funFact: "🕵️ Tylko 2 z 12 szpiegów złożyło zachęcający raport!"
      },
      medium: {
        question: "Którzy szpiedzy zachęcali lud do wejścia do ziemi?",
        options: [
          "Aaron i Mojżesz",
          "Jozue i Kaleb",
          "Gad i Aszer",
          "Ruben i Symeon"
        ],
        hint: "Dwaj mężowie wiary, którzy widzieli Boże obietnice",
        funFact: "🦁 Jozue i Kaleb byli jedynymi ze swojego pokolenia, którzy weszli do Kanaanu!"
      },
      hard: {
        question: "Dlaczego Izrael wędrował 40 lat po pustyni?",
        options: [
          "Aby ich ukarać",
          "Z powodu ich niewiary w Boże obietnice",
          "Aby przeszkolić ich do walki",
          "Aby znaleźć właściwą drogę"
        ],
        hint: "Chodzi o brak zaufania do Boga",
        funFact: "🏜️ Całe pokolenie musiało umrzeć z powodu niewiary!"
      }
    }
  }
};

export default chapter2Translations;
